import type { Role } from '../api/types'

/** Role helpers mirroring the API's policies (architecture §6). */
export function hasAnyRole(roles: readonly Role[], ...wanted: Role[]): boolean {
  return wanted.some((r) => roles.includes(r))
}

export const CAN_MANAGE_RANCH: Role[] = ['ranch-owner', 'ranch-manager', 'platform-admin']
export const CAN_OWN: Role[] = ['ranch-owner', 'platform-admin']
/** Record capture: measurements, herd records, notes (architecture §6 CanCapture). */
export const CAN_CAPTURE: Role[] = [
  'ranch-owner',
  'ranch-manager',
  'ranch-hand',
  'vet-tech',
  'platform-admin',
]
